module.exports = __webpack_public_path__ + "static/scale-model-of-lemur-lookout-in-dallas-texas-36a020b4e1c5b2b846fcb16b7378ba46.png";